<template>
  <delivery-item
      v-bind:class="getErrors()['shipping_method_code'] ? 'has-error' : ''"
      v-for="(item,idx) in deliveries"
      :model-value="modelValue"
      :item="item"
      @update:modelValue="() => {$emit('update:modelValue', item.id)}"
  />
</template>

<script>
import DeliveryItem from "./delivery-item";

export default {
    inject: ['getErrors'],
  name: "CheckoutDeliveries",
  emits: ['update:modelValue'],
  props: ['item', 'modelValue'],
  components: {DeliveryItem},
  data() {
    return {
      cartData: window.cartData,
      deliveries: [],
    }
  },
  mounted() {
    window.addEventListener('cartUpdated', this.loadCartData)
  },
  methods:{
    loadCartData(){
      this.cartData = window.cartData
    }
  },
  computed: {
    deliveries() {
      let rest_of_money = this.cartData.products.reduce((a,b) => a + (b.price * b.quantity), 0) >= 500 ? false : 500 - this.cartData.products.reduce((a,b) => a + (b.price * b.quantity), 0);
      let result_rest = '';
      if(rest_of_money) {
        result_rest += 'למשלוח חינם נשאר להזמין עוד ';
        result_rest += rest_of_money;
        result_rest += ' ש"ח';
      }
      return [
        {
          id: 'ups',
          name: 'שליח עד הבית',
          price: this.cartData.products.reduce((a,b) => a + (b.price * b.quantity), 0) >= 500 ? 0 : 45,
          info: [
            'עד 3 ימי עסקים',
            result_rest,
          ]
        },
        {
          id: 'pickup',
          name: 'איסוף עצמי',
          price: 0,
          info: [/*
            'הצורן 4, בפסאז\', ת.ד. 8819 נתניה 4250604',
            '  ימי ו\' וערבי חג 10:00-14:00',
            'א\'-ה\' 10:00-19:00'*/
          ]
        }
      ]
    },
    style() {
      return {
        display: this.item.id === this.modelValue ? 'block' : ''
      }
    }
  }
}
</script>

<style scoped>

</style>
